







































































































































































































import Vue from 'vue'
import SquareBlock from '@/components/map/SquareBlock.vue'
import Room from '@/components/map/Room.vue'
import Staircase from '@/components/map/Staircase.vue'
import SharedRoom from '@/components/map/SharedRoom.vue'
export default Vue.extend({
  components: { Staircase, Room, SquareBlock, SharedRoom },
  props: {
    patients: {
      type: Array,
      required: true,
    },
    patientsByRoomNumber: {
      type: Object,
      required: true,
    },
    sharedRooms: {
      type: Object,
      required: true,
    },
    searchQuery: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      sharedRoomsData: this.sharedRooms,
    }
  },
  computed: {
    roomsTopLeft() {
      return [26, 25, 24, 23, 22, 21, 20, 19, 18, 17, 16, 15, 14, 13, 12].map(room => ({
        roomNumber: room,
        isLonger: [22, 23].includes(room) ? true : false,
      }))
    },
    roomsBottomLeft() {
      return [9, 8, 7].map(room => ({
        roomNumber: room,
      }))
    },
    roomsTopRight() {
      return [27, 28, 29, 30, 31, 32].map(room => ({
        roomNumber: room,
      }))
    },
    roomsBottomRight() {
      return [1, 2, 3, 4, 5, 6].map(room => ({
        roomNumber: room,
      }))
    },
  },
})
